module.exports = __webpack_public_path__ + "static/media/birthday-sky.0c8e37b8.jpg";